// hooks/useVoteHandler.ts
import { useContext, useEffect, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import type { DemoItem } from "common/utils/helper";
import AppContext from "Contexts/AppContext";
import UserContext from "Contexts/User";
import { CurrentCMPDispatchContext } from "Contexts/CurrentCMP";
import VoteEndPopup from "Components/PopupModal/VoteEndPopup";

type CastVoteRequest = {
  matchupId: string;
  vote: "up" | "down";
  userId: string;
  multiplier: number;
};

type VoteCounts = {
  up: number;
  down: number;
  total: number;
};

type CastVoteResponse = {
  updatedVotes?: VoteCounts;
};

export const useVoteHandler = (
  userInfo: any,
  setItems: React.Dispatch<React.SetStateAction<DemoItem[]>>,
  voteFunctionName: string = "castVoteForDailyMatchup"  // New parameter
) => {
  const { setHeaderCpmStart, prevCMP, latestCMP, setCompletedVoteCMP } = useContext(AppContext);
  const { boosterVote } = useContext(AppContext)
  const setCurrentCMP = useContext(CurrentCMPDispatchContext);
  const { user } = useContext(UserContext);

  const castVoteFunction = httpsCallable<CastVoteRequest, CastVoteResponse>(
    functions,
    voteFunctionName  // Use the parameter instead of hardcoded value
  );
  const [isLoadingResult, setIsLoadingResult] = useState(false);

  const StartAnimation = (CmpScore: any) => {
    setCurrentCMP(
      (CmpScore || 0) +
      parseFloat(localStorage.getItem(`${user?.uid}_newScores`) || "0")
    );
    //@ts-ignore
    let prevScore: any = userInfo?.voteStatistics?.score % 100;
    prevCMP.current = prevScore.toFixed(3);
    let latestScore: any = (
      Number(prevScore) +
      Number(CmpScore || 0) +
      //@ts-ignore
      parseFloat(localStorage.getItem(`${user?.uid}_newScores`))
    ).toFixed(3);
    latestCMP.current = latestScore;
    localStorage.setItem(`${user?.uid}_prevScores`, prevScore);
    localStorage.setItem(`${user?.uid}_prevScoresHeader`,

      `${parseFloat(localStorage.getItem(`${user?.uid}_prevScoresHeader`) || "0")}`
    );
    console.log(prevScore, "checkprevScore5")
    // if (!pathname.toLowerCase().includes(`profile/mine`)) {
    localStorage.setItem(
      `${user?.uid}_newScores`,
      `${(CmpScore || 0) +
      parseFloat(localStorage.getItem(`${user?.uid}_newScores`) || "0")
      }`
    );
    localStorage.setItem(
      `${user?.uid}_newScoresHeader`,
      `${Number(CmpScore || 0) +
      parseFloat(localStorage.getItem(`${user?.uid}_newScoresHeader`) || "0")
      }`
    );
    setCompletedVoteCMP(CmpScore || 0);
  };


  const vote = async (id: string, voteType: "up" | "down") => {
    try {
      setIsLoadingResult(true);
      const { data } = await castVoteFunction({
        matchupId: id,
        vote: voteType,
        userId: userInfo.uid,
        multiplier: boosterVote > 0 ? boosterVote : 1,
      });
      setHeaderCpmStart(true);
      setTimeout(() => {
        // @ts-ignore
        StartAnimation(data?.cmp);
      }, 100);
      console.log(data, "alldataValue");
      setItems((prev) =>
        prev.map((it) =>
          it.id === id
            ? { ...it, vote: data?.updatedVotes ?? it.vote, voted: true, votedOption: voteType }
            : it
        )
      );
    } catch (err) {
      console.error("vote error", err);
      // Rollback (simple): set vote back to none for that item
      setItems((prev) =>
        prev.map((it) =>
          it.id === id
            ? { ...it, vote: { up: 0, down: 0, total: 0 }, voted: false, votedOption: null }
            : it
        )
      );
    } finally {
      setIsLoadingResult(false);
    }
  };

  return { vote, isLoadingResult };
};
